import { Component, OnInit, Inject, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, Validators, AbstractControl } from '@angular/forms';
import { FdFieldConfigs } from 'src/app/shared/fd-form-components/fd-form-components.module';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { LoadingService } from 'src/app/shared/service/loading.service';
import { FdSelectConfig, Item } from 'src/app/shared/fd-form-components/fd-select/fd-select.component';
import { takeWhile } from 'rxjs/operators';
import { MccPhysicalPersonModel, MccPhysicalPersonHistoryModel, SearchMccPhysicalPersonHistoryModel } from '../../models/mcc-physical-person.model';
import { MccService } from '../../services/mcc.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-history-mccs',
    templateUrl: './history-mcc.component.html',
    styleUrls: ['./history-mcc.component.scss'],
    standalone: false
})
export class HistoryMccComponent implements OnInit, OnDestroy {

  formGroup: UntypedFormGroup;
  fields: FdFieldConfigs;
  selectedInstitution: string;
  alive = true;
  toggleMessage: string;
  selectedItems: Item[] = [];
  technology: String = "NENHUMA";
  techDisabled : boolean;
  mccPhysicalHistoryModel: MccPhysicalPersonHistoryModel[] = new Array<MccPhysicalPersonHistoryModel>();
  filters: SearchMccPhysicalPersonHistoryModel = new SearchMccPhysicalPersonHistoryModel;
  @Input() dataSource: MatTableDataSource<MccPhysicalPersonHistoryModel>;
  
  ngOnInit() {
    this.getHistoryMcc();
    this.dialogRef.updateSize('60%', '60%');
    this.formGroup = this.createFormGroup();
    this.fields = this.createFields();
    this.formControls.institution.setValue(this.formatWithLeadingZeros(Number(this.data.activities.institution)));
    this.changeSelectedInstitution(this.formatWithLeadingZeros(Number(this.data.activities.institution)));
  }

  ngOnDestroy() {
    this.alive = false;
  }

  constructor(
        private formBuilder: UntypedFormBuilder,
        private dialogRef: MatDialogRef<HistoryMccComponent>,
        private loadingService: LoadingService,
        private mccService: MccService,
            @Inject(MAT_DIALOG_DATA) public data: {
            institution: string,
            activities: MccPhysicalPersonModel
            },
        private dialog: MatDialog

    ) { }

  changeSelectedInstitution(institution: string) {
    this.selectedInstitution = institution;

    setTimeout(() => {
      (this.fields.serviceContract as FdSelectConfig).items.map(x => x.selected = x.value === this.data.activities.serviceContract);
      this.formControls.serviceContract.setValue(this.data.activities.serviceContract);
    },2500)

  }

  getHistoryMcc() {
      this.filters.id = this.data.activities.id;
      this.filters.mcc = this.data.activities.mcc;
      this.loadingService.show();
      
      this.mccService.getMccPhysicalPersonHistory(this.filters)
        .pipe(takeWhile(() => this.alive))
        .subscribe(response => {
        this.buildMccPhysicalHistory(response);
          this.loadingService.hide();
        }, error => {
          this.loadingService.hide();
          this.mccDropdown.items = [];
        });
    }

  get mccDropdown() {
    return this.fields.mcc as FdSelectConfig;
  }


  buildMccPhysicalHistory(mccPhysicalHistoryModel: MccPhysicalPersonHistoryModel[]){
    mccPhysicalHistoryModel.forEach(itemDetails => {
      this.mccPhysicalHistoryModel.push({
      name: itemDetails.name,
      cpfCnpj: itemDetails.cpfCnpj,
      status: itemDetails.status,
      createdDate: itemDetails.createdDate,
      institution: itemDetails.institution,
      serviceContract: itemDetails.serviceContract,
      mcc: itemDetails.mcc,
      mccDescription: itemDetails.mccDescription });
    });
  };

  formatWithLeadingZeros(value: number, totalLength: number = 8): string {
    return value.toString().padStart(totalLength, '0');
  }

  getfieldsSelected(data: MccPhysicalPersonModel){

    this.formGroup.controls.mccFilter.setValue(
      data.mcc + data.mccDescription
    );
    this.formGroup.controls.institution.setValue(
      data.institution
    );
    this.formGroup.controls.serviceContract.setValue(
      data.serviceContract
    );
  }

  public isFormGroupValid(formGroup?: UntypedFormGroup): boolean {
    const formToBeValidated = !!formGroup ? formGroup : this.formGroup;
    if (formToBeValidated.invalid) {
      this.showErrorMessages(formToBeValidated);
      return false;
    }
    return true;
  }

  private showErrorMessages(formToBeValidated: UntypedFormGroup | UntypedFormArray) {
    let control;
    Object.keys(formToBeValidated.controls)
      .reverse()
      .forEach(field => {
        control = formToBeValidated.get(field);
        if (control instanceof UntypedFormArray ||
          control instanceof UntypedFormGroup) {
          this.showErrorMessages(control);
        } else {
          if (control && control.invalid) {
            control.markAsTouched();
          }
        }
      });
  }

  protected createFormGroup() {
    return this.formBuilder.group({
      mcc: ['', Validators.required],
      mccDescription: ['', Validators.required],
      serviceContract: ['', Validators.required],
      institution: ['', Validators.required]
    });
  }

  get formControls(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  close() {
    this.dialogRef.close();
  }

  get hasServiceContract() {
    return this.formControls.serviceContract && this.formControls.serviceContract.value;
  }

  createFields(): FdFieldConfigs {
    return {
      institution: {
        label: 'Nº Instituição',
        controlName: 'institution',
        maskCharsReplace: /[. / -]/g,
        panelWidth: '320px',
        messages: {
          required: 'Informe uma instituição',
          invalid: 'Usuário inválido'
        }
      },
      serviceContract: {
        label: 'Service Contract',
        controlName: 'serviceContract',
        maskCharsReplace: /[. / -]/g,
        panelWidth: '320px',
        messages: {
          required: 'Informe um service contract',
          invalid: 'Usuário inválido'
        }
      },
       mcc: {
        label: 'MCC',
        controlName: 'mcc',
        items: [],
        searchable: true,
        searchPlaceholder: 'Insira o MCC',
        panelWidth: '320px',
        messages: {
          required: 'campo obrigatório'
        }
      }
    };
  }

  applyFormatRefexFilterMccDescription(mccDescription: string):string {
    if(!mccDescription) return '';

    return /^\d{4}\s*-\s*/.test(mccDescription)
      ? mccDescription.replace(/^\d{4}\s*-\s*/, '').trim()
      : mccDescription.trim();
  }

}
